<template>
  <v-app-bar
    color="primary"
    class="px-5"
    app
    dark
    v-show="$store.getters.isLogin"
  >
    <v-toolbar-title>
      <v-img
        :src="logo_topo"
        width="150"
        alt=""
        style="cursor: pointer"
        @click="$router.push({ path: 'list-cam' }).catch(() => {})"
      />
    </v-toolbar-title>

    <v-row align="center" justify="space-around" class="mt-0 mb-1 px-12 mx-12">
      <v-col cols="5" class="py-0">
        <v-select
          v-model.trim="hostIdActive"
          prepend-inner-icon="mdi-map-marker"
          append-icon="mdi-chevron-down"
          laz
          flat
          dense
          hide-details
          outlined
          item-text="descr"
          :return-object="false"
          item-value="hostId"
          :items="$store.getters.listHost"
          label="Local"
        />
      </v-col>
      <v-col cols="3" class="mr-4">
        <v-btn
          color="white"
          outlined
          block
          class="rounded-md mt-0"
          @click="configNotificacao"
          v-show="isShowMod(30)"
          ><telegram-icon
            style="fill: #25a3e1; background-color: #fff"
            class="color-icon mr-1 rounded-xl"
            size="1.5x"
          ></telegram-icon>
          Notificação</v-btn
        >
      </v-col>
    </v-row>
    <v-menu bottom offset-y transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn :loading="!disabledMenu ? true : false" fab text
          ><v-icon v-bind="attrs" v-on="on" dark large>
            mdi-account-circle
          </v-icon></v-btn
        >
      </template>
      <v-list v-show="disabledMenu">
        <v-list-item @click="dark = !dark">
          <v-icon>{{ themeDark }}</v-icon>
          <v-list-item-title>{{ dark ? "escuro" : "claro" }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="startStopCam"
          :disabled="$store.getters.getStatusCams == null ? true : false"
          v-show="isShowMod(70)"
        >
          <v-icon
            >mdi-{{ $store.getters.getStatusCams ? "stop" : "play" }}</v-icon
          >
          <v-list-item-title>
            {{ $store.getters.getStatusCams ? "Parar" : "Iniciar " }}
            monitoramento</v-list-item-title
          >
        </v-list-item>
        <v-list-item
          :disabled="$store.getters.infoHost.hostId.length > 0 ? false : true"
          @click="realizarScan"
          v-show="isShowMod(60)"
        >
          <v-icon>mdi-magnify-scan</v-icon>
          <v-list-item-title> Realizar Configuração</v-list-item-title>
        </v-list-item>
        <v-list-item @click="minhasCameras">
          <v-icon>mdi-cctv</v-icon>
          <v-list-item-title>Minhas câmeras</v-list-item-title>
        </v-list-item>
        <v-list-item @click="perfilLocal">
          <v-icon>mdi-card-account-details-outline</v-icon>
          <v-list-item-title>Perfil e local</v-list-item-title>
        </v-list-item>
        <v-list-item @click="alterarSenha" v-show="isShowMod(40)">
          <v-icon>mdi-lock</v-icon>
          <v-list-item-title>Alterar Senha</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item @click="descricaoLocal" v-show="isShowMod(5)">
          <v-icon>mdi-office-building-marker</v-icon>
          <v-list-item-title>Descrição do local</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item @click="meusDados" v-show="isShowMod(10)">
          <v-icon>mdi-card-account-details</v-icon>
          <v-list-item-title>Meus dados</v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="usuarios" v-show="isShowMod(20)">
          <v-icon>mdi-account-group</v-icon>
          <v-list-item-title>Usuários</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item @click="configNotificacao" v-show="isShowMod(30)">
          <telegram-icon class="color-icon" size="1.5x"></telegram-icon>
          <v-list-item-title>Notificação</v-list-item-title>
        </v-list-item> -->

        <v-list-item @click="minhaAssinatura" v-show="isShowMod(80)">
          <v-icon>mdi-credit-card-multiple-outline</v-icon>
          <v-list-item-title> Minha Assinatura</v-list-item-title>
        </v-list-item>
        <v-list-item @click="dialoag_question_download = true">
          <v-icon>mdi-download</v-icon>
          <v-list-item-title>Download AlertMe</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item
          @click="dialogCancelamento = true"
          :disabled="$store.getters.getCodePlan.length > 0 ? false : true"
          v-show="isShowMod(90)"
        >
          <v-icon>mdi-credit-card-remove</v-icon>
          <v-list-item-title> Cancelar assinatura</v-list-item-title>
        </v-list-item> -->
        <v-list-item @click="sair">
          <v-icon>mdi-exit-to-app</v-icon>
          <v-list-item-title>sair</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog v-model="dialogStop" max-width="360">
      <v-card>
        <v-card-title class="headline" color="primary">Aviso</v-card-title>

        <v-card-text> Deseja realmente parar o monitoramento? </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="dialogStop = false">
            fechar
          </v-btn>

          <v-btn color="success darken-1" text @click="emitStartStop">
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCancelamento" max-width="360">
      <v-card>
        <v-card-title class="headline" color="primary">Aviso</v-card-title>

        <v-card-text> Deseja realmente cancelar sua assinatura? </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-1"
            text
            @click="dialogCancelamento = false"
          >
            fechar
          </v-btn>

          <v-btn color="success darken-1" text @click="cancelarAssinatura">
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogChangeLocal" max-width="360" persistent>
      <v-card>
        <v-card-title class="headline" color="primary">Login</v-card-title>
        <v-card-text>
          <v-form class="col-12">
            <v-text-field
              :append-icon="showPwdBd ? 'mdi-eye-off' : 'mdi-eye'"
              :type="showPwdBd ? 'text' : 'password'"
              @click:append="showPwdBd = !showPwdBd"
              v-model.trim="$v.pwd.$model"
              :error-messages="passwordError"
              prepend-icon="mdi-lock"
              disable
              name="password"
              label="Senha"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error darken-1" text @click="cancelarChangeLocal">
            Cancelar
          </v-btn>

          <v-btn
            color="success darken-1"
            text
            @click="loginLocal"
            :disabled="$v.$invalid || disableSubmit ? true : false"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Scan
      @close="closeScan"
      :openFrmScan="windowScan"
      :listCamExist="$store.getters.getListCams"
      :limitCam="$store.getters.infoHost.cams"
    />
    <!-- dialog notificacao -->
    <v-dialog
      v-model="dialogNotificacao"
      width="80%"
      transition="slide-y-reverse-transition"
      overlay-opacity="0.90"
      scrollable
    >
      <v-card tile class="rounded-t-xl rounded-b-xl">
        <v-toolbar flat dark color="primary" class="rounded-t-xl">
          <v-toolbar-title class="d-flex flex-wrap flex-row align-center">
            <telegram-icon
              style="fill: #25a3e1; background-color: #fff"
              class="color-icon mr-1 rounded-xl"
              size="1.5x"
            ></telegram-icon
            >Notificação</v-toolbar-title
          >
          <v-spacer />
          <v-toolbar-items>
            <v-btn color="" dark icon right @click="dialogNotificacao = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <Notification />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :absolute="true" :value="dialoag_question_download">
      <v-dialog v-model="dialoag_question_download" persistent max-width="360">
        <v-card>
          <v-toolbar flat color="transparent" class="rounded-t-xl">
            <v-toolbar-title class="d-flex flex-wrap flex-row align-center">
              <v-icon>mdi-download</v-icon> Download Alertme</v-toolbar-title
            >
            <v-spacer />
            <v-toolbar-items>
              <v-btn
                color=""
                dark
                icon
                right
                @click="dialoag_question_download = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            Você está no computador que irá fazer a integração e o monitoramento
            das suas câmeras?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="error darken-1"
              text
              @click.prevent="closeDialogDownload"
            >
              não
            </v-btn>

            <v-btn
              color="success darken-1"
              text
              @click.prevent="downloadAlertme"
            >
              Sim
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-overlay :absolute="true" :value="dialoag_info_download">
      <v-dialog v-model="dialoag_info_download" persistent max-width="360">
        <v-card>
          <v-toolbar flat color="transparent" class="rounded-t-xl">
            <v-toolbar-title class="d-flex flex-wrap flex-row align-center">
              Aviso</v-toolbar-title
            >
            <v-spacer />
            <v-toolbar-items>
              <v-btn icon right @click="dialoag_info_download = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            Se conecte no computador que irá fazer o monitoramento e faça o
            download lá.
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
  </v-app-bar>
</template>
<style>
.color-icon {
  fill: rgba(0, 0, 0, 0.54);
}
</style>
<script>
import Notification from "../components/minha-conta/Notification";
import { TelegramIcon } from "vue-simple-icons";
import { existsProp } from "../services/utils";
import { required, minLength } from "vuelidate/lib/validators";
import Scan from "../components/scan/Scan";
import moment from "moment";
export default {
  components: { Scan, TelegramIcon, Notification },
  name: "Menu",
  data() {
    return {
      dialoag_info_download: false,
      dialoag_question_download: false,
      //
      dialogNotificacao: false,
      //
      windowScan: false,
      dialogChangeLocal: false,
      showPwdBd: false,
      dialogCancelamento: false,
      dialogStop: false,
      logo_topo: require("@/assets/logo_h.png"),
      drawer: false,
      disableBtn: false,
      dark: true,
      changeLocal: null,
      pwd: null,
      showLogo: true,
      disabledMenu: false,
      hostIdActive: null,
      paginaRedirect: null,
    };
  },
  methods: {
    closeDialogDownload() {
      this.dialoag_question_download = false;
      this.dialoag_info_download = true;
    },
    downloadAlertme() {
      this.dialoag_question_download = false;
      window.open("https://google.com.br");
    },
    isShowMod(codigo) {
      return this.$alertme.checkMod(codigo);
    },
    closeScan() {
      this.windowScan = false;
      //
      this.$root.$emit("initMonitor");
    },
    realizarScan() {
      //
      this.windowScan = !this.windowScan;
      this.$root.$emit("stopMonitor");
    },
    updateInfoHost() {
      let hostId = this.getHostId();
      if (hostId == null && hostId.length <= 0) {
        this.$store.dispatch("setMsgError", "Informações do host inválida!");
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      this.$alertme.getInfoHostId(hostId).then((res) => {
        if (existsProp(res.data, "instance")) {
          this.$store.dispatch("setInfoHost", res.data.instance);
        }
      });
    },
    isValidAssinatura(value) {
      if (value == null && value.length <= 0) {
        return false;
      }
      let vcto = moment(value);
      if (!vcto._isValid) {
        return false;
      }
      let now = moment();
      let diff = vcto.diff(now, "hours");
      return diff >= 0 ? true : false;
    },
    startStopCam() {
      if (
        this.$store.getters.totalCamsConfigurada >
        this.$store.getters.infoHost.cams
      ) {
        this.$store.dispatch(
          "setMsgError",
          "Qtde de câmeras do plano está inferior a configurada!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      if (this.$store.getters.totalCamsConfigurada == 0) {
        this.$store.dispatch("setMsgError", "Nenhuma câmera foi configurada!");
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }

      if (this.$store.getters.getCodePlan === false) {
        this.$store.dispatch("setMsgError", "Informações do host inválida!");
        this.$store.dispatch("setDisplayMsgErr", true);
        this.updateInfoHost();
        return;
      }
      if (
        (this.$store.getters.getCodePlan !== false &&
          this.$store.getters.getCodePlan.length <= 0 &&
          this.isValidAssinatura(this.$store.getters.infoHost.end_date) ==
            false) ||
        this.$store.getters.infoHost.cams == 0
      ) {
        this.$store.dispatch(
          "setMsgError",
          "Antes de iniciar o monitoramento você precisar comprar um plano!"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        this.minhaAssinatura();
        return;
      }
      if (this.$store.getters.getStatusCams) {
        this.dialogStop = true;
        return;
      }
      this.emitStartStop();
      //
    },
    emitStartStop() {
      this.dialogStop = false;
      this.$emit("changeMonitoramento");
    },
    getHostId() {
      return this.$alertme.getHostIdUrl(this.$route);
    },
    cancelarAssinatura() {
      let data = {
        hostId: this.getHostId(),
      };
      this.$alertme
        .cancelarAssinatura(data)
        .then((res) => {
          if (existsProp(res.data, "message")) {
            if (res.data.message != "ok") {
              this.$store.dispatch("setMsgError", res.data.message);
              this.$store.dispatch("setDisplayMsgErr", true);
              return;
            }
            this.$store.commit("setRedirect", "");
            //
            this.updateInfoHost();
            this.dialogCancelamento = false;
            this.$store.dispatch(
              "MsgSucces",
              "Seu plano foi cancelado. Alertme será interrompido em 3 dias"
            );
            this.$store.dispatch("displayMsgSuccess", true);
          }
        })
        .catch((e) => {
          this.$store.dispatch("setMsgError", e.message);
          this.$store.dispatch("setDisplayMsgErr", true);
        });
    },
    sair() {
      this.$alertme.signOut(this.$store.getters.hostActive);
      this.$store.dispatch("setCams", []);
      this.$store.dispatch("setListStatusCams", []);
      this.$store.dispatch("setStatusCams", null);
      //
      this.$root.stopMessages();
    },
    cancelarChangeLocal() {
      this.hostIdActive = this.$store.getters.hostActive;
      this.dialogChangeLocal = false;
      // this.$store.dispatch("setHostActive", value);
    },
    changeLogin() {
      let email = this.$store.getters.getEmail;
      let data = {
        user: email,
        // pwd: this.$alertme.md5(this.pwd),
        pwd: this.$store.getters.getPwd,
        hostId: this.hostIdActive,
      };
      this.$alertme.signIn(data).then(
        (res) => {
          this.disableSubmit = false;
          this.dialogChangeLocal = false;
          //exibi msg
          if (res.data.message && res.data.message != "ok") {
            this.$store.dispatch("setMsgError", res.data.message);
            this.$store.dispatch("setDisplayMsgErr", true);
            this.redirectLoginLocal("login");
            return;
          }
          this.paginaRedirect = "home";
          //
          this.$store.dispatch("MsgSucces", "Login efetuado com sucesso!");
          this.$store.dispatch("displayMsgSuccess", true);
          this.$store.dispatch("setHostActive", this.hostIdActive);
          this.$store.dispatch("setToken", true);
          //
    
          let host = this.$alertme.getInfoHostUser(email, this.hostIdActive);
          host.mod = res.data.mod;
          if (!this.$alertme.setAuthHostUser(email, this.hostIdActive, host)) {
            this.$store.dispatch("setMsgError", "Erro ao realizar login");
            this.$store.dispatch("setDisplayMsgErr", true);
            return false;
          }
          //buscando perfil
          this.$alertme
            .getPerfil({ hostId: this.hostIdActive })
            .then(
              (res) => {
                if (res.data.status) {
                  this.$store.dispatch("setPerfil", {});
                } else {
                  this.$store.dispatch("setPerfil", res.data.value);
                }
                this.pwd = null;
                //
                //
              },
              () => {
                this.$store.dispatch("setPerfil", {});
              }
            )
            .finally(() => {
              this.disableSubmit = false;
              this.redirectLoginLocal("list-cam");
            });
        },
        () => {
          this.disableSubmit = false;
          this.$store.dispatch("resetToken");
          this.$store.dispatch(
            "setMsgError",
            "Não foi possivel realizar login!"
          );
          this.$store.dispatch("setDisplayMsgErr", true);
          this.redirectLoginLocal("login");
        }
      );
    },
    redirectLoginLocal(pagina) {
      this.$router
        .push({
          name: pagina,
          params: pagina != "login" ? { hostId: this.hostIdActive } : {},
        })
        .catch(() => {});
    },
    loginLocal() {
      this.disableSubmit = true;
      let hostId = this.$store.getters.hostActive;
      //
      this.$root.stopMonitorStatusCam();
      this.$root.deleteAllMessageServer();
      //
      this.paginaRedirect = "login";
      this.$alertme.logout(hostId).then(
        (res) => {
          if (res.data.status == 0) {
            this.$store.dispatch("MsgSucces", res.data.msg);
            this.$store.dispatch("displayMsgSuccess", true);
          }
          this.$store.dispatch("resetToken");
          this.$store.dispatch("setCams", []);
          this.redirectLoginLocal("login");
          this.changeLogin();
        },
        (e) => {
          if (e.response) {
            this.$store.dispatch("setMsgError", e.response.data.msg);
            this.$store.dispatch("setDisplayMsgErr", true);
          }
          this.redirectLoginLocal(this.paginaRedirect);
        }
      );
    },
    meusDados() {
      this.$router.push({ name: "meus-dados" }).catch(() => {});
    },
    descricaoLocal() {
      this.$router.push({ name: "descricao-local" }).catch(() => {});
    },
    usuarios() {
      this.$router.push({ name: "usuarios" }).catch(() => {});
    },
    minhasCameras() {
      let hostId = this.$store.getters.hostActive;
      this.$router
        .push({ name: "list-cam", params: { hostId } })
        .catch(() => {});
    },
    minhaAssinatura() {
      this.$router.push({ name: "minha-assinatura" }).catch(() => {});
    },
    perfilLocal() {
      this.$router.push({ name: "perfil-local" }).catch(() => {});
    },
    configNotificacao() {
      // this.$router.push({ name: "configuracao-notificacao" }).catch(() => {});
      this.dialogNotificacao = true;
    },
    alterarSenha() {
      this.$router.push({ name: "perfil-local",hash:"#user-pwd"}).catch(() => {});
    },
    openBasket() {
      if (this.$route.name != "sacola") {
        this.$router.push({ name: "sacola" }).catch(() => {});
      }
    },
    voltarVendedor() {
      window.location.href = localStorage.getItem("referrer");
    },
  },
  validations: {
    pwd: {
      required,
      minLength: minLength(6),
    },
  },
  computed: {
    disableSubmit: {
      set(value) {
        this.disableBtn = value;
      },
      get() {
        return this.disableBtn;
      },
    },
    passwordError() {
      const errors = [];
      const password = this.$v.pwd;
      if (!password.$dirty) {
        return errors;
      }
      !password.required && errors.push("Senha é obrigatorio");
      !password.minLength && errors.push(`Senha inválida`);
      return errors;
    },
    themeDark: {
      get() {
        return this.dark ? "mdi-brightness-4" : "mdi-brightness-7";
      },
      set(value) {
        this.dark = value;
      },
    },
    qtdCart() {
      return new String(this.$store.getters.countItemBasket);
    },
  },
  watch: {
    dark(value, old) {
      this.$vuetify.theme.dark = old;
      if (old) {
        this.$store.dispatch("darkOn");
      } else {
        this.$store.dispatch("lightOn");
      }
    },
    hostIdActive(value, old) {
      if (
        old != null &&
        value != null &&
        this.$store.getters.hostActive != value
      ) {
        // this.dialogChangeLocal = true;
        this.changeLogin();


      }
    },
    "$store.getters.hostActive"() {
      this.hostIdActive = this.$store.getters.hostActive;
    },
  },
  created() {
    this.dark = !this.$store.getters.getPreferThemeUser;
    this.$vuetify.theme.dark = this.$store.getters.getPreferThemeUser;
    this.menuAtivo = Object.assign({}, this.$store.getters.menuAtivo);
    let logo = localStorage.getItem("referrer");
    this.showLogo = logo != null && logo.length > 0 ? false : true;
    setTimeout(() => {
      this.disabledMenu = true;
    }, 15000);
    //
    this.$root.$on("openWindowScan", () => {
      if (!this.isShowMod(60)) {
        this.$store.dispatch(
          "setMsgError",
          "Seu usuário não tem permissão para realizar configuração de câmeras"
        );
        this.$store.dispatch("setDisplayMsgErr", true);
        return;
      }
      this.realizarScan();
    });
  },
};
</script>